<template>
  <v-app-bar
    color="black"
    flat
    dark
    app
    clipped-left
  >
    <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    <router-link
      to="/"
      class="pl-0 pr-0 ml-2"
    >
      <img
        :src="logo"
        height="40px"
        class="contain"
      />
    </router-link>

    <SelectEmpFil/>

    <v-spacer></v-spacer>

    <!-- <v-btn icon class="mr-2">
      <v-icon>mdi-cog</v-icon>
    </v-btn> -->
    <v-menu 
      v-if="user"
      offset-y
      transition="scale-transition"
      origin="top center"
      >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          text
          height=50
          elevation="0"
          class="mr-1"
        >
          <v-avatar size="40">
            <img
              v-if="user.photoURL"
              :src="user.photoURL"
              alt="Avatar"
            >
            <v-gravatar 
              v-else
              :email="user.email"
              default-img="mm"/>
          </v-avatar>
          <v-toolbar-title class="subtitle-1 no-text-transform ml-2">{{user.displayName}}</v-toolbar-title>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="signOut">
          <template>
            <v-list-item-content>
              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon>mdi-account-arrow-right</v-icon>
            </v-list-item-icon>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import SelectEmpFil from "@/components/Templates/SelectEmpFil"
import { createNamespacedHelpers, mapState } from 'vuex'
const { mapState:authState, mapActions:authActions } = createNamespacedHelpers('auth')
export default {
  name: 'AppBar',
  components: {SelectEmpFil},
  computed: {
    ...authState(['user']),
    drawer: {
      get(){
        return this.$store.state.drawer
      },
      set(val){
        this.$store.commit('setDrawer', val)
      } 
    },      
    logo() {
      return this.$appConfig.logo ? this.$appConfig.logo :  '@/assets/logo.png'
    },
  },
  methods: {
    ...authActions(['signOut']),
  }
}
</script>

<style>

</style>